import {
  getOriginalHeight,
  getOriginalWidth,
} from './index';

import { getLayoutObjectByLayoutId } from './layouts';

export function setEditorLayout(page, layouts, bookProperties) {
  const getLayoutSizes = getLayoutObjectByLayoutId(page.layout, layouts);

  let ratio = 1;
  let width = 0;
  let height = 0;

  if (getLayoutSizes) {
    const {
      width: layoutWidth,
      height: layoutHeight,
    } = getLayoutSizes;

    const bookSizes = {
      width: layoutWidth,
      height: layoutHeight,
    };


    const editorDOM = document.querySelector('.Editor');

    if (editorDOM) {
      ratio = editorDOM.offsetHeight / getOriginalHeight(bookSizes);
      if (getOriginalHeight(bookSizes) * ratio * 2 > editorDOM.offsetWidth) {
        ratio = editorDOM.offsetWidth / (getOriginalHeight(bookSizes) * 2);
      }
    }

    if (!page.isCover) {
      width = Math.floor(getOriginalWidth(bookSizes) * ratio);
      height = Math.floor(getOriginalHeight(bookSizes) * ratio);
    }
  }


  return {
    width,
    height,
  };
}



// WEBPACK FOOTER //
// ./src/redux/helpers/editor.js